module.exports = __webpack_public_path__ + "static/media/icon-chevron-up_thick.78e14641.svg";